require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./dispatchemailertest.json") })
        }
      }, "path---dispatchemailertest");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---dispatchemailertest!./.cache/json/dispatchemailertest.json
// module id = 711
// module chunks = 231608221292675